<template>
  <div class="bg-light">
    <top-bar @reload="buscarCaixas()"/>
    <div class="content pt-4">
      <div class="container-fluid">
        <loading v-show="load" text="Carregando os dados"/>
        <div v-show="!load">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <router-link to="/home" class="btn btn-outline-dark"><i class="fa fa-chevron-left mr-1"></i> Voltar</router-link>
            </div>
            <div>
              <button class="btn btn-secondary" @click="$refs.modalCaixa.abrirCaixa()"><i class="fa fa-plus mr-1"></i> Novo Caixa</button>
            </div>
          </div>
          <hr>
          <div class="card shadow-sm mb-3">
            <div class="card-body text-center text-md-left">
              <div class="row justify-content-center">
                <div class="col-md-6 col-lg-3 mb-1">
                  <label class="small font-weight-bold mb-0">Pesquisar</label>
                  <input type="search" class="form-control" placeholder="Número ou nome do caixa" v-model="pesquisa.termo" @search="buscarCaixas()">
                </div>
                <div class="col-md-6 col-lg-3 mb-1">
                  <label class="small font-weight-bold mb-0">Data</label>
                  <input type="date" class="form-control" v-model="pesquisa.date">
                </div>
                <div class="col-md-6 col-lg-3 mb-1">
                  <label class="small font-weight-bold mb-0">Status</label>
                  <select class="form-control" id="status" v-model="pesquisa.status">
                    <option value="">Todos</option>
                    <option value="1">Abertos</option>
                    <option value="2">Fechados</option>
                  </select>
                </div>
                <div class="col-md-6 col-lg-3 mb-1">
                  <label class="small font-weight-bold mb-0">Conferido</label>
                  <select class="form-control" id="conferido" v-model="pesquisa.conferido">
                    <option value="">Todos</option>
                    <option value="1">Sim</option>
                    <option value="0">Não</option>
                  </select>
                </div>
                <div class="col-md-3 mt-3">
                  <button class="btn btn-warning btn-block" @click="buscarCaixas()">Pesquisar</button>
                </div>
              </div>
            </div>
          </div>
          <div class="card shadow-sm mb-4">
            <div class="card-body">
              <div class="table-responsive" style="min-height: 150px">
                <table class="table mb-0">
                  <thead class="border-bottom small">
                  <tr>
                    <th>Caixa</th>
                    <th>Aberto / Fechado</th>
                    <th>Conferido</th>
                    <th>&nbsp;</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr class="pointer" v-for="c in caixas">
                    <td @click="selCaixa(c.id_caixa)">
                      <span>#{{c.id_caixa}} - </span>
                      <span class="pr-2">{{c.nome}}</span>
                      <span class="badge badge-success" v-if="c.status === '1'">Aberto</span>
                      <span class="badge badge-dark" v-else-if="c.status === '2'">Fechado</span>
                      <span class="badge badge-danger" v-else>Cancelado</span>
                    </td>
                    <td @click="selCaixa(c.id_caixa)">{{c.dt_cadastro}}
                      <span class="px-1">-</span>
                      {{c.dt_finalizacao}}
                    </td>
                    <td>{{c.conferido === '1' ? "Sim" : "Não"}}</td>
                    <td class="text-nowrap text-right">
                      <button class="btn btn-primary btn-sm mr-1" @click="selCaixa(c.id_caixa)" title="Editar Caixa"><i class="fa fa-pencil-alt"></i></button>
                      <button class="btn btn-dark btn-sm" @click="removerCaixa(c.id_caixa)" title="Remover caixa"><i class="fa fa-trash-alt"></i></button>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="d-flex justify-content-between border-top pt-3">
                <div>
                  <button class="btn btn-sm btn-outline-info" @click="buscarCaixas(--pesquisa.page)" :disabled="pesquisa.page <= 0">
                    <i class="fas fa-chevron-left"></i> Anterior
                  </button>
                </div>
                <div>
                  <button class="btn btn-sm btn-outline-info" @click="buscarCaixas(++pesquisa.page)" :disabled="caixas.length < 30">
                    Próximo <i class="fas fa-chevron-right"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <admin-caixas-form @fechar="buscarCaixas(pesquisa.page)" :admin="true"/>
        <caixa ref="modalCaixa" :admin="true" @finalizarVenda="atualizarCaixas()"/>
      </div>
    </div>
  </div>
</template>

<script>
  import TopBar from "../../../components/commons/TopBar";
  import Loading from "../../../components/commons/Loading";
  import AdminCaixasForm from './AdminCaixasForm.vue';
  import Caixa from "../pdv/Caixa";

  export default {
    name: 'AdminCaixas',
    components: {Caixa, Loading, AdminCaixasForm, TopBar },
    data() {
      return {
        token: localStorage.getItem('key'),
        caixas: [],
        load: true,
        pesquisa: {
          page: 0,
          date: '',
          conferido: '',
          termo: '',
          status: ''
        }
      }
    },

    methods: {
      selCaixa(id_caixa) {
        this.$emit('openModalCaixa', id_caixa);
      },

      atualizarCaixas() {
        this.$swal("Caixa aberto com sucesso!");
        this.buscarCaixas()
      },

      buscarCaixas(page) {
        this.load = true;
        this.pesquisa.page = page || 0;

        this.$http.get('caixas/' + this.token, {params: this.pesquisa})
          .then(response => {
            this.load = false;
            this.caixas = response.data || [];

          }, res => {
            this.load = false;
            this.$swal(res.data && res.data.msg ? res.data.msg : "Erro Temporário");
          });
      },

      removerCaixa(id_caixa) {
        this.$swal({
          text: `Deseja remover este caixa?`,
          buttons: ["Cancelar", "Sim!"]
        }).then((result) => {
          if (result) {
            this.load = true;
            this.$http.post("caixas/remover/" + this.token, { id_caixa })
              .then(res => {
                this.load = false;

                if (res.data && res.data.success) {
                  this.$swal("O caixa foi removido com sucesso.");
                  this.buscarCaixas();

                } else {
                  this.$swal(res.data && res.data.msg ? res.data.msg : "Erro Temporário");
                }

              }, res => {
                this.load = false;
                this.$swal(res.data && res.data.msg ? res.data.msg : "Erro Temporário");
              });
          }
        });
      },
    },

    mounted() {
      this.buscarCaixas();
    }
  }
</script>

<style scoped>
</style>
